import { render } from "./NavigationIcons.vue?vue&type=template&id=12c4de00&ts=true"
import script from "./NavigationIcons.vue?vue&type=script&lang=ts"
export * from "./NavigationIcons.vue?vue&type=script&lang=ts"

import exportComponent from "/home/app/mt-partners/frontend/affiliate/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__